import React from 'react'
import * as actions from '../../store/actions/index';

import DeleteModal from './DeleteModal';
import { useSelector } from 'react-redux'
import { useHistory } from "react-router-dom";
import { ROUTES } from '../../routes';

const DeleteProjectModal = (props) => {

  const history = useHistory();

  const projectId = useSelector(state => state.modal.modalProps.projectId)
  const thisProject = useSelector(state => {
    return (projectId) => actions.getProject(state, projectId)
  });


  const onSubmitAction = () => {
    return actions.deactivateProject(projectId)
  };

  const redirectTo = () => {
    return history.push(ROUTES.TO_PROJECTS)
  };

  const modalTitle = "Projekt archivieren";
  const projectname = thisProject(projectId).title;

  return (
    <DeleteModal
      modalTitle={modalTitle}
      onSubmitAction={onSubmitAction}
      redirectTo={redirectTo}
      submitTitle="Projekt archivieren"
    >
    <p>Wollen Sie das Projekt <strong>{projectname}</strong> archivieren?</p>
    </DeleteModal>
  )
}

export default DeleteProjectModal



// WEBPACK FOOTER //
// ./src/components/Modals/DeactivateProjectModal.js